
	import { defineComponent } from 'vue';

	import FiscalYearReportByParticipant from '@/ChildrenComponents/Reports/FiscalYearReportByParticipant.vue';

	import { ISupervisionContactReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';

    import { ReportService } from '@/Services/Report/report-service';

	export default defineComponent({
		name: 'supervision-contact-report',
		components: { FiscalYearReportByParticipant },
		data () {
			return {
				reportData: [] as ISupervisionContactReport[],
				isSearching: false,
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				ReportService.getSupervisionContactReportData(searchDto).then(response => this.reportData = response).finally(() => this.isSearching = false);
			}
		},
	});
